import { Component, inject } from '@angular/core'
import { AuthService } from '@auth0/auth0-angular'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'

@Component({
    selector: 'sf-access-denied',
    imports: [ButtonComponent],
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss',
})
export class AccessDeniedComponent {
    authService = inject(AuthService)
    year = new Date().getFullYear()

    login(): void {
        this.authService.loginWithRedirect()
    }

    logout(): void {
        this.authService.logout({ logoutParams: { returnTo: window.location.origin } })
    }
}
